/**
 * Created by Languagenut on 24/04/2019.
 */


import React  from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import validateVat from 'validate-vat-ts';
import FieldGroup from '../components/FieldGroup.js';
import LicenceService from '../services/licence-service.js';
import LicenceStore   from '../store/licence-store.js';
import Constants from '../constants.js';
import {Row , Col , Card  , Form } from "react-bootstrap";
import {PaypalPayment , DirectDebitPayment , CardPayment , InvoicePayment} from '../components/payments';
import NumericInput from 'react-numeric-input';

export default class Payment extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            value: 50,
            paymentMethod:'invoice',
            discount:0.5,
            countries:[
                {
                    "country_code" : "AD",
                    "country_name" : "Andorra"
                },
                {
                    "country_code" : "AE",
                    "country_name" : "United Arab Emirates"
                },
                {
                    "country_code" : "AF",
                    "country_name" : "Afghanistan"
                },
                {
                    "country_code" : "AG",
                    "country_name" : "Antigua and Barbuda"
                },
                {
                    "country_code" : "AI",
                    "country_name" : "Anguilla"
                },
                {
                    "country_code" : "AL",
                    "country_name" : "Albania"
                },
                {
                    "country_code" : "AM",
                    "country_name" : "Armenia"
                },
                {
                    "country_code" : "AO",
                    "country_name" : "Angola"
                },
                {
                    "country_code" : "AQ",
                    "country_name" : "Antarctica"
                },
                {
                    "country_code" : "AR",
                    "country_name" : "Argentina"
                },
                {
                    "country_code" : "AS",
                    "country_name" : "American Samoa"
                },
                {
                    "country_code" : "AT",
                    "country_name" : "Austria"
                },
                {
                    "country_code" : "AU",
                    "country_name" : "Australia"
                },
                {
                    "country_code" : "AW",
                    "country_name" : "Aruba"
                },
                {
                    "country_code" : "AX",
                    "country_name" : "Aland Islands"
                },
                {
                    "country_code" : "AZ",
                    "country_name" : "Azerbaijan"
                },
                {
                    "country_code" : "BA",
                    "country_name" : "Bosnia and Herzegovina"
                },
                {
                    "country_code" : "BB",
                    "country_name" : "Barbados"
                },
                {
                    "country_code" : "BD",
                    "country_name" : "Bangladesh"
                },
                {
                    "country_code" : "BE",
                    "country_name" : "Belgium"
                },
                {
                    "country_code" : "BF",
                    "country_name" : "Burkina Faso"
                },
                {
                    "country_code" : "BG",
                    "country_name" : "Bulgaria"
                },
                {
                    "country_code" : "BH",
                    "country_name" : "Bahrain"
                },
                {
                    "country_code" : "BI",
                    "country_name" : "Burundi"
                },
                {
                    "country_code" : "BJ",
                    "country_name" : "Benin"
                },
                {
                    "country_code" : "BL",
                    "country_name" : "Saint Barthelemy"
                },
                {
                    "country_code" : "BM",
                    "country_name" : "Bermuda"
                },
                {
                    "country_code" : "BN",
                    "country_name" : "Brunei Darussalam"
                },
                {
                    "country_code" : "BO",
                    "country_name" : "Bolivia, Plurinational State of"
                },
                {
                    "country_code" : "BQ",
                    "country_name" : "Bonaire, Sint Eustatius and Saba"
                },
                {
                    "country_code" : "BR",
                    "country_name" : "Brazil"
                },
                {
                    "country_code" : "BS",
                    "country_name" : "Bahamas"
                },
                {
                    "country_code" : "BT",
                    "country_name" : "Bhutan"
                },
                {
                    "country_code" : "BW",
                    "country_name" : "Botswana"
                },
                {
                    "country_code" : "BY",
                    "country_name" : "Belarus"
                },
                {
                    "country_code" : "BZ",
                    "country_name" : "Belize"
                },
                {
                    "country_code" : "CA",
                    "country_name" : "Canada"
                },
                {
                    "country_code" : "CC",
                    "country_name" : "Cocos (Keeling) Islands"
                },
                {
                    "country_code" : "CD",
                    "country_name" : "Congo, The Democratic Republic of The"
                },
                {
                    "country_code" : "CF",
                    "country_name" : "Central African Republic"
                },
                {
                    "country_code" : "CG",
                    "country_name" : "Congo"
                },
                {
                    "country_code" : "CH",
                    "country_name" : "Switzerland"
                },
                {
                    "country_code" : "CI",
                    "country_name" : "Cote D'ivoire"
                },
                {
                    "country_code" : "CK",
                    "country_name" : "Cook Islands"
                },
                {
                    "country_code" : "CL",
                    "country_name" : "Chile"
                },
                {
                    "country_code" : "CM",
                    "country_name" : "Cameroon"
                },
                {
                    "country_code" : "CN",
                    "country_name" : "China"
                },
                {
                    "country_code" : "CO",
                    "country_name" : "Colombia"
                },
                {
                    "country_code" : "CR",
                    "country_name" : "Costa Rica"
                },
                {
                    "country_code" : "CU",
                    "country_name" : "Cuba"
                },
                {
                    "country_code" : "CV",
                    "country_name" : "Cabo Verde"
                },
                {
                    "country_code" : "CW",
                    "country_name" : "Curacao"
                },
                {
                    "country_code" : "CY",
                    "country_name" : "Cyprus"
                },
                {
                    "country_code" : "CZ",
                    "country_name" : "Czech Republic"
                },
                {
                    "country_code" : "DE",
                    "country_name" : "Germany"
                },
                {
                    "country_code" : "DJ",
                    "country_name" : "Djibouti"
                },
                {
                    "country_code" : "DK",
                    "country_name" : "Denmark"
                },
                {
                    "country_code" : "DM",
                    "country_name" : "Dominica"
                },
                {
                    "country_code" : "DO",
                    "country_name" : "Dominican Republic"
                },
                {
                    "country_code" : "DZ",
                    "country_name" : "Algeria"
                },
                {
                    "country_code" : "EC",
                    "country_name" : "Ecuador"
                },
                {
                    "country_code" : "EE",
                    "country_name" : "Estonia"
                },
                {
                    "country_code" : "EG",
                    "country_name" : "Egypt"
                },
                {
                    "country_code" : "ER",
                    "country_name" : "Eritrea"
                },
                {
                    "country_code" : "ES",
                    "country_name" : "Spain"
                },
                {
                    "country_code" : "ET",
                    "country_name" : "Ethiopia"
                },
                {
                    "country_code" : "FI",
                    "country_name" : "Finland"
                },
                {
                    "country_code" : "FJ",
                    "country_name" : "Fiji"
                },
                {
                    "country_code" : "FK",
                    "country_name" : "Falkland Islands (Malvinas)"
                },
                {
                    "country_code" : "FM",
                    "country_name" : "Micronesia, Federated States of"
                },
                {
                    "country_code" : "FO",
                    "country_name" : "Faroe Islands"
                },
                {
                    "country_code" : "FR",
                    "country_name" : "France"
                },
                {
                    "country_code" : "GA",
                    "country_name" : "Gabon"
                },
                {
                    "country_code" : "GB",
                    "country_name" : "United Kingdom"
                },
                {
                    "country_code" : "GD",
                    "country_name" : "Grenada"
                },
                {
                    "country_code" : "GE",
                    "country_name" : "Georgia"
                },
                {
                    "country_code" : "GF",
                    "country_name" : "French Guiana"
                },
                {
                    "country_code" : "GG",
                    "country_name" : "Guernsey"
                },
                {
                    "country_code" : "GH",
                    "country_name" : "Ghana"
                },
                {
                    "country_code" : "GI",
                    "country_name" : "Gibraltar"
                },
                {
                    "country_code" : "GL",
                    "country_name" : "Greenland"
                },
                {
                    "country_code" : "GM",
                    "country_name" : "Gambia"
                },
                {
                    "country_code" : "GN",
                    "country_name" : "Guinea"
                },
                {
                    "country_code" : "GP",
                    "country_name" : "Guadeloupe"
                },
                {
                    "country_code" : "GQ",
                    "country_name" : "Equatorial Guinea"
                },
                {
                    "country_code" : "GR",
                    "country_name" : "Greece"
                },
                {
                    "country_code" : "GT",
                    "country_name" : "Guatemala"
                },
                {
                    "country_code" : "GU",
                    "country_name" : "Guam"
                },
                {
                    "country_code" : "GW",
                    "country_name" : "Guinea-Bissau"
                },
                {
                    "country_code" : "GY",
                    "country_name" : "Guyana"
                },
                {
                    "country_code" : "HK",
                    "country_name" : "Hong Kong"
                },
                {
                    "country_code" : "HN",
                    "country_name" : "Honduras"
                },
                {
                    "country_code" : "HR",
                    "country_name" : "Croatia"
                },
                {
                    "country_code" : "HT",
                    "country_name" : "Haiti"
                },
                {
                    "country_code" : "HU",
                    "country_name" : "Hungary"
                },
                {
                    "country_code" : "ID",
                    "country_name" : "Indonesia"
                },
                {
                    "country_code" : "IE",
                    "country_name" : "Ireland"
                },
                {
                    "country_code" : "IL",
                    "country_name" : "Israel"
                },
                {
                    "country_code" : "IM",
                    "country_name" : "Isle of Man"
                },
                {
                    "country_code" : "IN",
                    "country_name" : "India"
                },
                {
                    "country_code" : "IO",
                    "country_name" : "British Indian Ocean Territory"
                },
                {
                    "country_code" : "IQ",
                    "country_name" : "Iraq"
                },
                {
                    "country_code" : "IR",
                    "country_name" : "Iran, Islamic Republic of"
                },
                {
                    "country_code" : "IS",
                    "country_name" : "Iceland"
                },
                {
                    "country_code" : "IT",
                    "country_name" : "Italy"
                },
                {
                    "country_code" : "JE",
                    "country_name" : "Jersey"
                },
                {
                    "country_code" : "JM",
                    "country_name" : "Jamaica"
                },
                {
                    "country_code" : "JO",
                    "country_name" : "Jordan"
                },
                {
                    "country_code" : "JP",
                    "country_name" : "Japan"
                },
                {
                    "country_code" : "KE",
                    "country_name" : "Kenya"
                },
                {
                    "country_code" : "KG",
                    "country_name" : "Kyrgyzstan"
                },
                {
                    "country_code" : "KH",
                    "country_name" : "Cambodia"
                },
                {
                    "country_code" : "KI",
                    "country_name" : "Kiribati"
                },
                {
                    "country_code" : "KM",
                    "country_name" : "Comoros"
                },
                {
                    "country_code" : "KN",
                    "country_name" : "Saint Kitts and Nevis"
                },
                {
                    "country_code" : "KP",
                    "country_name" : "Korea, Democratic People's Republic of"
                },
                {
                    "country_code" : "KR",
                    "country_name" : "Korea, Republic of"
                },
                {
                    "country_code" : "KW",
                    "country_name" : "Kuwait"
                },
                {
                    "country_code" : "KY",
                    "country_name" : "Cayman Islands"
                },
                {
                    "country_code" : "KZ",
                    "country_name" : "Kazakhstan"
                },
                {
                    "country_code" : "LA",
                    "country_name" : "Lao People's Democratic Republic"
                },
                {
                    "country_code" : "LB",
                    "country_name" : "Lebanon"
                },
                {
                    "country_code" : "LC",
                    "country_name" : "Saint Lucia"
                },
                {
                    "country_code" : "LI",
                    "country_name" : "Liechtenstein"
                },
                {
                    "country_code" : "LK",
                    "country_name" : "Sri Lanka"
                },
                {
                    "country_code" : "LR",
                    "country_name" : "Liberia"
                },
                {
                    "country_code" : "LS",
                    "country_name" : "Lesotho"
                },
                {
                    "country_code" : "LT",
                    "country_name" : "Lithuania"
                },
                {
                    "country_code" : "LU",
                    "country_name" : "Luxembourg"
                },
                {
                    "country_code" : "LV",
                    "country_name" : "Latvia"
                },
                {
                    "country_code" : "LY",
                    "country_name" : "Libya"
                },
                {
                    "country_code" : "MA",
                    "country_name" : "Morocco"
                },
                {
                    "country_code" : "MC",
                    "country_name" : "Monaco"
                },
                {
                    "country_code" : "MD",
                    "country_name" : "Moldova, Republic of"
                },
                {
                    "country_code" : "ME",
                    "country_name" : "Montenegro"
                },
                {
                    "country_code" : "MF",
                    "country_name" : "Saint Martin (French Part)"
                },
                {
                    "country_code" : "MG",
                    "country_name" : "Madagascar"
                },
                {
                    "country_code" : "MH",
                    "country_name" : "Marshall Islands"
                },
                {
                    "country_code" : "MK",
                    "country_name" : "Macedonia, The Former Yugoslav Republic of"
                },
                {
                    "country_code" : "ML",
                    "country_name" : "Mali"
                },
                {
                    "country_code" : "MM",
                    "country_name" : "Myanmar"
                },
                {
                    "country_code" : "MN",
                    "country_name" : "Mongolia"
                },
                {
                    "country_code" : "MO",
                    "country_name" : "Macao"
                },
                {
                    "country_code" : "MP",
                    "country_name" : "Northern Mariana Islands"
                },
                {
                    "country_code" : "MQ",
                    "country_name" : "Martinique"
                },
                {
                    "country_code" : "MR",
                    "country_name" : "Mauritania"
                },
                {
                    "country_code" : "MS",
                    "country_name" : "Montserrat"
                },
                {
                    "country_code" : "MT",
                    "country_name" : "Malta"
                },
                {
                    "country_code" : "MU",
                    "country_name" : "Mauritius"
                },
                {
                    "country_code" : "MV",
                    "country_name" : "Maldives"
                },
                {
                    "country_code" : "MW",
                    "country_name" : "Malawi"
                },
                {
                    "country_code" : "MX",
                    "country_name" : "Mexico"
                },
                {
                    "country_code" : "MY",
                    "country_name" : "Malaysia"
                },
                {
                    "country_code" : "MZ",
                    "country_name" : "Mozambique"
                },
                {
                    "country_code" : "NA",
                    "country_name" : "Namibia"
                },
                {
                    "country_code" : "NC",
                    "country_name" : "New Caledonia"
                },
                {
                    "country_code" : "NE",
                    "country_name" : "Niger"
                },
                {
                    "country_code" : "NF",
                    "country_name" : "Norfolk Island"
                },
                {
                    "country_code" : "NG",
                    "country_name" : "Nigeria"
                },
                {
                    "country_code" : "NI",
                    "country_name" : "Nicaragua"
                },
                {
                    "country_code" : "NL",
                    "country_name" : "Netherlands"
                },
                {
                    "country_code" : "NO",
                    "country_name" : "Norway"
                },
                {
                    "country_code" : "NP",
                    "country_name" : "Nepal"
                },
                {
                    "country_code" : "NR",
                    "country_name" : "Nauru"
                },
                {
                    "country_code" : "NU",
                    "country_name" : "Niue"
                },
                {
                    "country_code" : "NZ",
                    "country_name" : "New Zealand"
                },
                {
                    "country_code" : "OM",
                    "country_name" : "Oman"
                },
                {
                    "country_code" : "PA",
                    "country_name" : "Panama"
                },
                {
                    "country_code" : "PE",
                    "country_name" : "Peru"
                },
                {
                    "country_code" : "PF",
                    "country_name" : "French Polynesia"
                },
                {
                    "country_code" : "PG",
                    "country_name" : "Papua New Guinea"
                },
                {
                    "country_code" : "PH",
                    "country_name" : "Philippines"
                },
                {
                    "country_code" : "PK",
                    "country_name" : "Pakistan"
                },
                {
                    "country_code" : "PL",
                    "country_name" : "Poland"
                },
                {
                    "country_code" : "PM",
                    "country_name" : "Saint Pierre and Miquelon"
                },
                {
                    "country_code" : "PR",
                    "country_name" : "Puerto Rico"
                },
                {
                    "country_code" : "PS",
                    "country_name" : "Palestine, State of"
                },
                {
                    "country_code" : "PT",
                    "country_name" : "Portugal"
                },
                {
                    "country_code" : "PW",
                    "country_name" : "Palau"
                },
                {
                    "country_code" : "PY",
                    "country_name" : "Paraguay"
                },
                {
                    "country_code" : "QA",
                    "country_name" : "Qatar"
                },
                {
                    "country_code" : "RE",
                    "country_name" : "Reunion"
                },
                {
                    "country_code" : "RO",
                    "country_name" : "Romania"
                },
                {
                    "country_code" : "RS",
                    "country_name" : "Serbia"
                },
                {
                    "country_code" : "RU",
                    "country_name" : "Russian Federation"
                },
                {
                    "country_code" : "RW",
                    "country_name" : "Rwanda"
                },
                {
                    "country_code" : "SA",
                    "country_name" : "Saudi Arabia"
                },
                {
                    "country_code" : "SB",
                    "country_name" : "Solomon Islands"
                },
                {
                    "country_code" : "SC",
                    "country_name" : "Seychelles"
                },
                {
                    "country_code" : "SD",
                    "country_name" : "Sudan"
                },
                {
                    "country_code" : "SE",
                    "country_name" : "Sweden"
                },
                {
                    "country_code" : "SG",
                    "country_name" : "Singapore"
                },
                {
                    "country_code" : "SI",
                    "country_name" : "Slovenia"
                },
                {
                    "country_code" : "SK",
                    "country_name" : "Slovakia"
                },
                {
                    "country_code" : "SL",
                    "country_name" : "Sierra Leone"
                },
                {
                    "country_code" : "SM",
                    "country_name" : "San Marino"
                },
                {
                    "country_code" : "SN",
                    "country_name" : "Senegal"
                },
                {
                    "country_code" : "SO",
                    "country_name" : "Somalia"
                },
                {
                    "country_code" : "SR",
                    "country_name" : "Suriname"
                },
                {
                    "country_code" : "SS",
                    "country_name" : "South Sudan"
                },
                {
                    "country_code" : "ST",
                    "country_name" : "Sao Tome and Principe"
                },
                {
                    "country_code" : "SV",
                    "country_name" : "El Salvador"
                },
                {
                    "country_code" : "SX",
                    "country_name" : "Sint Maarten (Dutch Part)"
                },
                {
                    "country_code" : "SY",
                    "country_name" : "Syrian Arab Republic"
                },
                {
                    "country_code" : "SZ",
                    "country_name" : "Swaziland"
                },
                {
                    "country_code" : "TC",
                    "country_name" : "Turks and Caicos Islands"
                },
                {
                    "country_code" : "TD",
                    "country_name" : "Chad"
                },
                {
                    "country_code" : "TG",
                    "country_name" : "Togo"
                },
                {
                    "country_code" : "TH",
                    "country_name" : "Thailand"
                },
                {
                    "country_code" : "TJ",
                    "country_name" : "Tajikistan"
                },
                {
                    "country_code" : "TK",
                    "country_name" : "Tokelau"
                },
                {
                    "country_code" : "TL",
                    "country_name" : "Timor-Leste"
                },
                {
                    "country_code" : "TM",
                    "country_name" : "Turkmenistan"
                },
                {
                    "country_code" : "TN",
                    "country_name" : "Tunisia"
                },
                {
                    "country_code" : "TO",
                    "country_name" : "Tonga"
                },
                {
                    "country_code" : "TR",
                    "country_name" : "Turkey"
                },
                {
                    "country_code" : "TT",
                    "country_name" : "Trinidad and Tobago"
                },
                {
                    "country_code" : "TV",
                    "country_name" : "Tuvalu"
                },
                {
                    "country_code" : "TW",
                    "country_name" : "Taiwan, Province of China"
                },
                {
                    "country_code" : "TZ",
                    "country_name" : "Tanzania, United Republic of"
                },
                {
                    "country_code" : "UA",
                    "country_name" : "Ukraine"
                },
                {
                    "country_code" : "UG",
                    "country_name" : "Uganda"
                },
                {
                    "country_code" : "UM",
                    "country_name" : "United States Minor Outlying Islands"
                },
                {
                    "country_code" : "US",
                    "country_name" : "United States"
                },
                {
                    "country_code" : "UY",
                    "country_name" : "Uruguay"
                },
                {
                    "country_code" : "UZ",
                    "country_name" : "Uzbekistan"
                },
                {
                    "country_code" : "VA",
                    "country_name" : "Holy See"
                },
                {
                    "country_code" : "VC",
                    "country_name" : "Saint Vincent and The Grenadines"
                },
                {
                    "country_code" : "VE",
                    "country_name" : "Venezuela, Bolivarian Republic of"
                },
                {
                    "country_code" : "VG",
                    "country_name" : "Virgin Islands, British"
                },
                {
                    "country_code" : "VI",
                    "country_name" : "Virgin Islands, U.S."
                },
                {
                    "country_code" : "VN",
                    "country_name" : "Viet Nam"
                },
                {
                    "country_code" : "VU",
                    "country_name" : "Vanuatu"
                },
                {
                    "country_code" : "WF",
                    "country_name" : "Wallis and Futuna"
                },
                {
                    "country_code" : "WS",
                    "country_name" : "Samoa"
                },
                {
                    "country_code" : "YE",
                    "country_name" : "Yemen"
                },
                {
                    "country_code" : "YT",
                    "country_name" : "Mayotte"
                },
                {
                    "country_code" : "ZA",
                    "country_name" : "South Africa"
                },
                {
                    "country_code" : "ZM",
                    "country_name" : "Zambia"
                },
                {
                    "country_code" : "ZW",
                    "country_name" : "Zimbabwe"
                }
            ],
            isEstablishment:false,
            hasDiscount:false,
            vatNumber:0.2,
            licence:{

            }

        }

        this.userData = {

        }

    }

    componentDidMount() {
        LicenceService.get(this.props.match.params.id)
    }

    componentWillMount() {
        LicenceStore.on(Constants.ON_GOT_LICENCE , () => {
            this.setState({
                package:{
                    currency_amount:10.00
                },
                packageLicences:LicenceStore.get(this.props.match.params.id).licence,
                isEstablishment:0
            })

            console.log(LicenceStore.get(this.props.match.params.id))
        });
    }

    discount(subtotal)
    {
        if(!this.state.discount) return subtotal

        this.discountAmountNubmer = subtotal*this.state.discount

        return Number(subtotal) - Number(this.discountAmountNubmer)
    }

    vatAmount(subtotal)
    {
        if(!this.state.vatNumber) return subtotal;

        this.vatAmountNumber = subtotal*this.state.vatNumber;

        return subtotal + this.vatAmountNumber
    }

    calculateCost(){

        if(!this.state.package)
        {
            return 0;
        }

        var cost     = 0;
        var subTotal = 0;
        var packagePrice = Number(this.state.package.currency_amount)

        subTotal += packagePrice;


        var discountedAmount =this.discount(Number(subTotal));

        return this.vatAmount(discountedAmount).toFixed(2);

    }

    getEstablishmentOptions(){
        if(!this.state.isEstablishment) return null;

        return [
            <Col md={6}>
                <FieldGroup
                    value={this.userData.establishmentName}
                    id="account_name"
                    type="text"
                    label="Establishment Name"
                    placeholder="Enter text"
                    onChange={(event)=>{  this.userData.establishmentName = event.target.value}}
                    />
            </Col>,
            <Col md={6}>
                <FieldGroup
                    id="account_name"
                    type="text"
                    label="VAT Number (optional)"
                    placeholder="Enter text"
                    help={this.state.vatMSG}
                    state={this.state.VAT_CORRECT ? 'success' : this.state.VAT_ERROR ? 'error' : ''}
                    onChange={this.matchVATCountry.bind(this)}
                    />
            </Col>
        ]
    };

    getPaymentMethods(){


           return  [<Col md={4}>
               <div onClick={this.setPaymentMethod.bind(this , "invoice")} class={this.state.paymentMethod == "invoice" ? "selected-payment btn-primary" : "payment-method"}>
                   <center >Invoice</center>
                   <center><small>Xero</small></center>
               </div>
           </Col>
        ];


    }

    matchVATCountry(e){
        const countryCode = e.target.value.slice(0, 2); // First two letters of EE123456789

        if(countryCode.length == 0)
        {
            this.setState({
                vatMSG:'',
                VAT_ERROR:false,
                VAT_CORRECT:false
            });
            return;
        }

        if (countryCode !== this.state.countryCode) {
            this.setState({
                vatMSG:'VAT number does not match selected country',
                VAT_ERROR:true,
            });
        }
        else
        {
            this.matchVATNumber(e.target.value);
        }
    }

    matchVATNumber(vat){

        let countryNumbers = vat.slice(2); // Numbers part of the VAT number
        validateVat(this.state.countryCode, countryNumbers, (error, info) => {
            if (error) {
                this.setState({
                    vatMSG:'Unable to validate VAT number',
                    VAT_ERROR:true,
                });
                return
            }
            if (!info.valid) {

                this.setState({
                    vatMSG:'Invalid VAT number',
                    VAT_ERROR:true,
                });
            }
        });
    }

    handelCountryCodeChange(e){
        this.setState({
            countryCode:e.target.value
        })
    }

    setPaymentMethod(method){

        this.setState({
            paymentMethod:method,
        });
    }

    getPaymentMethod()
    {
        this.userData.vatNumber = this.state.vatNumber;
        this.userData.billingAddressCountry = this.state.countryCode

        switch(this.state.paymentMethod)
        {
            case "card" :
                return <CardPayment packageData={LicenceStore.get(this.props.match.params.id)}  userData={this.userData} />
                break;
            case "paypal":
                return <PaypalPayment packageData={LicenceStore.get(this.props.match.params.id)}  userData={this.userData} />
            case "directDebit":
                return <DirectDebitPayment packageData={LicenceStore.get(this.props.match.params.id)}  userData={this.userData} />
            case "invoice":
                return <InvoicePayment packageData={LicenceStore.get(this.props.match.params.id)}  userData={this.userData} />
            default: return null;
        }
    }

    handleOnChange(additionalIndex , value){

        if(Number(value) >= Number(this.state.packageLicences[additionalIndex].max_changeable_number)){
            value = this.state.packageLicences[additionalIndex].max_changeable_number
        }

        if(Number(value) < Number(this.state.packageLicences[additionalIndex].number_free)){
            value = this.state.packageLicences[additionalIndex].number_free
        }


        LicenceStore.setExtraValue(this.props.match.params.id , additionalIndex , value)
    }


    getAddtionalLicences(){


        if(!this.state.packageLicences ||  this.state.packageLicences.length == 0) return  <hr/>;

        let sliders = [];



        for(var idx = 0 ; idx < this.state.packageLicences.length; idx++)
        {
            if(!this.state.packageLicences[idx].payment_display) continue;
            if(this.state.packageLicences[idx].number_changable == 0) continue;


            sliders.push(
                    <tr>
                    <td align="center">
                        <center><h6>Additional Languages</h6></center>
                        <Slider

                                min={Number(this.state.packageLicences[idx].number_free)}
                                max={Number(this.state.packageLicences[idx].max_changeable_number)}
                                step={1}
                                value={Number(this.state.packageLicences[idx].number) || Number(this.state.packageLicences[idx].number_free)}
                                onChange={this.handleOnChange.bind(this , idx)}
                                />
                       </td>
                </tr>,
                <tr>
                    <td align="center">

                        <NumericInput  style={{width:'30px'}} onChange={this.handleOnChange.bind(this , idx)} min={Number(this.state.packageLicences[idx].number_free)} max={Number(this.state.packageLicences[idx].max_changeable_number)} value={Number(this.state.packageLicences[idx].number) || Number(this.state.packageLicences[idx].number_free)}/>
                    </td>
                </tr>
            )


        }


        return <div><table width="100%">{sliders}</table><hr/></div>;
    }

    render(){

        const { value } = this.state;

        let options = [];

        for(var idx = 0 ; idx < this.state.countries.length; idx++)
        {
            options.push( <option value={this.state.countries[idx].country_code}>{this.state.countries[idx].country_name}</option>)
        }

        return <Row>
            <Col md={{ span: 4, offset: 1 }}>
                <Card>
                    <Card.Body>
                        <Card.Title>Languagenut Student</Card.Title>
                        <ul className="features-list">
                            <li>Access to 22 modern foreign languages including French, German and Spanish</li>
                            <li>1440 words and phrases</li>
                            <li>24 units of 6 sections each</li>
                            <li>10 sentence-building sentences per unit</li>
                            <li>14 speaking, listening, reading and writing games</li>
                        </ul>
                        {this.getAddtionalLicences()}

                        <table style={{width:"100%"}}>
                            <tr><td><h5>Discount</h5>
                                </td><td align="right">{this.state.discount*100}%</td></tr>
                            <tr><td><h5>VAT</h5></td><td align="right">{Math.round((this.state.vatNumber)*100)}%</td></tr>
                        </table>
                        <hr/>
                        <center>
                            <h4>£{this.calculateCost()} <small>(GBP)</small></h4>
                        </center>
                    </Card.Body>
                </Card>
                <br/>
            </Col>
            <Col md={6}>
                <Card body>
                    <Row>
                        <Col md={6}>
                            <FieldGroup
                                id="account_name"
                                type="text"
                                label="Name"
                                value={this.userData.firstName}
                                placeholder="Enter text"
                                onChange={(event)=>{  this.userData.firstName = event.target.value}}
                                />
                        </Col>
                        <Col md={6}>
                            <FieldGroup
                                id="account_name"
                                type="text"
                                label="Last Name"
                                value={this.userData.lastName}
                                placeholder="Enter text"
                                onChange={(event)=>{  this.userData.lastName = event.target.value}}
                                />
                        </Col>
                        <Col md={12}>
                            <FieldGroup
                                id="account_name"
                                type="text"
                                label="Email"
                                value={this.userData.lastName}
                                placeholder="Enter text"
                                onChange={(event)=>{  this.userData.email = event.target.value}}
                                />
                        </Col>
                        {this.getEstablishmentOptions(this.userData)}
                        <Col md={12}>
                            <FieldGroup
                                id="account_name"
                                type="text"
                                label="Street"
                                value={this.userData.street}
                                placeholder="Enter text"
                                onChange={(event)=>{  this.userData.billingAddressStreet = event.target.value}}

                                />
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="Form.ControlsSelect">
                                <Form.Label>Country</Form.Label>
                                <Form.Control onChange={this.handelCountryCodeChange.bind(this)} as="select" placeholder="select">
                                    {options}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <FieldGroup
                                id="account_name"
                                type="text"
                                label="Postcode"
                                placeholder="Enter text"
                                onChange={(event)=>{  this.userData.billingAddressPostalcode = event.target.value}}

                                />
                        </Col>
                    </Row>
                    <hr/>
                    <div>
                        <Row>
                            {this.getPaymentMethods()}
                        </Row>
                        <Row>
                            <Col md={12}>
                                {this.getPaymentMethod()}
                            </Col>
                        </Row>
                    </div>
                    <hr/>
                    <small>
                        You account will remain open for 7 days after
                    </small>
                </Card>
            </Col>
        </Row>

    }

}